<xemex-dialog-shell [title]="data.title">
  <div
    class="flex items-start gap-2 rounded-lg border border-amber-300 bg-status-warning p-3 text-sm text-amber-800"
  >
    <mat-icon class="mt-0.5 shrink-0 !h-5 !w-5 !text-[20px] text-amber-500">warning</mat-icon>
    <span>{{ data.message }}</span>
  </div>
  <div actions>
    <button mat-flat-button color="warn" [mat-dialog-close]="true">
      {{ data.confirmLabel }}
    </button>
    <button mat-stroked-button mat-dialog-close>
      {{ data.cancelLabel }}
    </button>
  </div>
</xemex-dialog-shell>
